import React, { useEffect, useState } from 'react';
import '../../styles/home/WebPreloader.css';
import logo from '../../../images/Logo/MrSea2025_logo_white.png'

const WebPreloader = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="web-preloader">
      <img src={logo} alt="Logo" className="web-preloader-logo" />
    </div>
  );
};

export default WebPreloader;